module.exports = __webpack_public_path__ + "img/Under 16 Icon - charcoal.3f11a595.svg";